import { render, staticRenderFns } from "./center-service-panel.vue?vue&type=template&id=c56f52a8&scoped=true"
import script from "./center-service-panel.vue?vue&type=script&lang=js"
export * from "./center-service-panel.vue?vue&type=script&lang=js"
import style0 from "./center-service-panel.vue?vue&type=style&index=0&id=c56f52a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f52a8",
  null
  
)

export default component.exports